import AvatarIcon from "@/assets/images/pictures/avatar_placeholder.svg?inline";
import EditIcon from "@/assets/images/icons/edit.svg?inline";
import LoadingIcon from "@/assets/images/icons/loading-white.svg?inline";

import { mapGetters, mapState } from "vuex";

import { AGENT_PROFILE } from "../gql/AgentProfileQueries";

export default {
  name: "public_agent_profile",

  data() {
    return {
      agentProfile: {},
      isOwner: false,
      isAboutMe: false,
      isNeedAboutHide: false
    };
  },

  apollo: {
    agentProfile: {
      query: AGENT_PROFILE,
      fetchPolicy: "no-cache",
      variables() {
        return {
          id: this.$route.params.id
        };
      },
      result() {
        this.$nextTick(() => {
          this.matchAboutHeight();
        });
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUser: "getUser"
    }),

    ...mapState(["twilioMessagesCounter"]),

    isMessagesAvaliable() {
      return this.twilioMessagesCounter != null;
    },

    isProfileOwner() {
      if (
        this.currentUser.role == "agent" &&
        this.currentUser.id == this.agentProfile.userInfo.id
      ) {
        return (this.isOwner = true);
      }
    }
  },

  methods: {
    matchAboutHeight() {
      if (this.agentProfile.userInfo.aboutMe) {
        this.isNeedAboutHide = this.$refs.aboutMe.clientHeight > 200;
        // 200 - height of 7 text rows
      }
    }
  },

  watch: {
    $route() {
      this.isAboutMe = false;
    }
  },

  components: {
    AvatarIcon,
    EditIcon,
    LoadingIcon
  }
};
